import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const AUTH_MY_PAGE_LANG: {
  AUTH_CHANGED_YOUR_PASSWORD: MvnCodeFE;
  AUTH_LOGOUT_DESCRIPTION: MvnCodeFE;
  AUTH_LOGOUT_NOTIFICATION: MvnCodeFE;
} = {
  AUTH_CHANGED_YOUR_PASSWORD: {
    ko: "비밀번호를 변경하시겠습니까?",
    en: "Change your password?",
  },
  AUTH_LOGOUT_DESCRIPTION: {
    ko: "비밀번호 변경 시 기존 로그인들이 모두 로그아웃 됩니다.",
    en: "When changing the password, all existing logins will be logged out.",
  },
  AUTH_LOGOUT_NOTIFICATION: {
    ko: "기존 로그인들이 로그아웃 되었습니다.",
    en: "Existing logins have been logged out.",
  },
};

MvnCodeInitiate(AUTH_MY_PAGE_LANG);
